import { AutofillInputComponent } from './components/autofill-input/autofill-input.component';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAlertModule, NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { IconsModule } from './icons/icons.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableComponent } from './components/table/table.component';
import { TableHeaderComponent } from './components/table-header/table-header.component';
import { ModalComponent } from './components/modal/modal.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FilterContainerComponent } from './components/filter-container/filter-container.component';
import { ReplaceEmptyStringPipe } from './pipes/replace-empty-string.pipe';
import { SelectRolesComponent } from './components/select-roles/select-roles.component';
import {
    ContentDirective,
    FormatCurrencyDirective,
    InputValidatorDirective,
    SaveButtonFormValidityDirective,
    TabContentDirective
} from './directives';
import { TooltipDirective } from './directives/tooltip';
import { PermissionModule } from './permission/permission.module';
import { DateTimePipe, ReplaceNullPipe, RolesPipe } from './pipes';
import { FormContainerCenteredComponent } from './custom-form/components/form-container-centered/form-container-centered.component';
import { SimpleTabComponent } from './components/simple-tab/simple-tab.component';
import { SimpleTabsComponent } from './components/simple-tabs/simple-tabs.component';
import { TabComponent } from './components/tab';
import { BadgeComponent } from './components/badge/badge.component';
import { TabsetComponent } from './components/tabset';
import { TabsetOutletComponent } from './components/tabset-outlet';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { HourPickerComponent } from './components/hour-picker/hour-picker.component';
import { RelativeDatePipe } from './pipes/relative-date.pipe';

const COMPONENTS = [
    AutofillInputComponent,
    CheckboxComponent,
    ConfirmModalComponent,
    DropdownComponent,
    FilterContainerComponent,
    ModalComponent,
    SearchInputComponent,
    SelectRolesComponent,
    SpinnerComponent,
    TableComponent,
    TableHeaderComponent,
    SimpleTabComponent,
    SimpleTabsComponent,
    FormContainerCenteredComponent,
    BadgeComponent,
    TabComponent,
    TabsetComponent,
    TabsetOutletComponent,
    DatePickerComponent,
    MultiSelectComponent,
    DateRangeComponent,
    HourPickerComponent
];

const DIRECTIVES = [
    ContentDirective,
    InputValidatorDirective,
    SaveButtonFormValidityDirective,
    TabContentDirective,
    FormatCurrencyDirective
];

const PIPES = [DateTimePipe, RelativeDatePipe, ReplaceEmptyStringPipe, ReplaceNullPipe, RolesPipe];

const MODULES = [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    IconsModule,
    NgbAlertModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgSelectModule,
    PermissionModule,
    ReactiveFormsModule,
    TranslateModule
];

@NgModule({
    imports: [...MODULES, TooltipDirective],
    declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
    exports: [...COMPONENTS, ...DIRECTIVES, ...PIPES, ...MODULES, TooltipDirective],
    providers: [...PIPES],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
